import {
  RESET_FAQ_MESSAGE,
  GET_FAQ_SUCCESS,
  GET_FAQ_FAIL,
  ADD_FAQ_SUCCESS,
  ADD_FAQ_FAIL,
  UPDATE_FAQ_SUCCESS,
  UPDATE_FAQ_FAIL,
  DELETE_FAQ_SUCCESS,
  DELETE_FAQ_FAIL,
} from "./actionTypes";

const initialState = {
  faqs: [],
  success: {
    message: "",
  },
  error: {
    message: "",
  },
};

const FaqReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_FAQ_MESSAGE:
      state = {
        ...state,
        success: { message: "" },
        error: { message: "" },
      };
      break;
    case GET_FAQ_SUCCESS:
      state = { ...state, faqs: action.payload?.data || [] };
      break;
    case GET_FAQ_FAIL:
      state = { ...state, error: action.payload };
      break;
    case ADD_FAQ_SUCCESS:
      state = { ...state, success: action.payload || [] };
      break;
    case ADD_FAQ_FAIL:
      state = { ...state, error: action.payload };
      break;
    case UPDATE_FAQ_SUCCESS:
      state = { ...state, success: action.payload || [] };
      break;
    case UPDATE_FAQ_FAIL:
      state = { ...state, error: action.payload };
      break;
    case DELETE_FAQ_SUCCESS:
      state = { ...state, success: action.payload || [] };
      break;
    case DELETE_FAQ_FAIL:
      state = { ...state, error: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default FaqReducer;
